module.exports = (__webpack_require__(5))(42);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/component.jsx from dll-reference forms
// module id = 2
// module chunks = 0